import './index.css';
import Navbar from "./components/Navbar";
import Home from "./components/Home";
// import Players from "./components/Players";
import Players1 from "./components/Players1";
// import Standings from "./components/Standings";
import Standings1 from "./components/Standings1";
import Fixtures from "./components/Fixtures";
import Stadium from "./components/Stadium";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // npm i react-router-dom



function App() {
  return (
    <Router>
    <div className="App">
      <Navbar />
        <Routes>
          <Route path='/' element={<Home />}></Route>
          {/* <Route path='players' element={<Players />}></Route> */}
          <Route path='players' element={<Players1 />}></Route>
          <Route path='standings' element={<Standings1 />}></Route>
          {/* <Route path='standings' element={<Standings />}></Route> */}
          <Route path='fixtures' element={<Fixtures />}></Route>
          <Route path='stadium' element={<Stadium />}></Route>
        </Routes>
      
      <Footer/>
    </div>
  </Router>
  );
}

export default App;
